import {Formik} from 'formik';
import {FormWithButtons} from '@flexinet/ui-components';

import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';
import {ProductFormValues} from '../types';

type RecordFormProps = {
    initialValues: ProductFormValues,
    // Returns the mutation's promise. Formik awaits it: isSubmitting stays true
    // (Save disabled) until it settles, and a rejection leaves the form as it
    // was for the operator to correct.
    onSubmit: (values: ProductFormValues) => Promise<unknown>,
    onCancel: () => void,
};

export const RecordForm = ({initialValues, onSubmit, onCancel}: RecordFormProps) => (
    <Formik
        initialValues={initialValues}
        validationSchema={RecordSchema}
        onSubmit={async (values) => onSubmit(values)}
    >
        {({handleSubmit, isSubmitting}) => (
            <FormWithButtons
                handleSubmit={handleSubmit}
                isSubmitting={isSubmitting}
                handleCancel={() => onCancel()}
            >
                <FormComponent/>
            </FormWithButtons>
        )}
    </Formik>
);
